import type { ReactNode } from "react"
import { cn } from "@quibas/integration-hub-ui/lib/utils"

/** Procurement's system status layout: vector illustration, message and recovery actions. */
export function SystemStatusView({ actions, contained = false, description, illustration, role, title }: {
  actions: ReactNode
  contained?: boolean
  description: string
  illustration: ReactNode
  role?: "alert" | "status"
  title: string
}) {
  return (
    <main className={cn("flex items-center justify-center bg-background px-6 text-foreground", contained ? "flex-1 rounded-xl py-10" : "min-h-dvh py-12")}>
      <section className="flex w-full max-w-md flex-col items-center gap-8 text-center" role={role}>
        {illustration}
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">{actions}</div>
      </section>
    </main>
  )
}
